import { LOADER_START, LOADER_STOP } from './constant';

const initialState = {
    loader: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADER_START:
            return {
                ...state,
                loader: true,
            };

        case LOADER_STOP:
            return {
                ...state,
                loader: false,
            };

        default:
            return state;
    }
};
